export default __webpack_public_path__ + "static/media/upArrow.a0979e45.svg";